// extracted by mini-css-extract-plugin
module.exports = {"tooltipContent":"Tooltip_tooltipContent__1iRJx","col":"Tooltip_col__qC6qY","clickable":"Tooltip_clickable__2Iw_q"};